<template>
  <div>
    <ValidationObserver
      v-slot="{ handleSubmit }"
      ref="validator"
    >
      <div class="md-layout-item md-size-100">
        <form @submit.prevent="handleSubmit(submitForm)">
          <div
            class="md-layout-item"
            style="margin-bottom: 15px;"
          >
            <label style="display: flex">Fotos</label>
            <div class="md-layout-item md-size-100">
              <drag-and-drop-component
                :current-images="activityImage"
                :title-image="activity.titleImage"
                :allow-multiple="false"
                @updateTitleImage="updateTitleImage($event)"
              />
            </div>
          </div>
          <div class="md-layout">
            <div
              class="md-layout-item"
              :class="{'md-size-100': fullWidth, 'md-size-50': !fullWidth }"
              style="display: flex"
            >
              <label class="dots bold">Sport</label>
              <md-field>
                <md-select
                  v-model="activity.activityType"
                  name="activity type"
                >
                  <md-option
                    v-for="item in activityTypes"
                    :key="item.number"
                    :label="item.label || item.type"
                    :value="item.number"
                  >
                    {{ item.label || item.typeitem.type }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div
              class="md-layout-item"
              :class="{'md-size-100': fullWidth, 'md-size-50 md-medium-size-100': !fullWidth }"
            >
              <ValidationProvider
                v-slot="{ passed, failed }"
                name="start"
                rules="required"
              >
                <div
                  class="date-time"
                  style="display:flex"
                >
                  <label class="dots bold">Start</label>
                  <md-field class="date-time">
                    <datetime
                      v-model="activity.start"
                      type="datetime"
                      input-class="form-control"
                      :min-datetime="minDatetime"
                      :max-datetime="maxDatetime"
                      format="dd:MM.yyyy HH:mm"
                    />
                    <slide-y-down-transition>
                      <md-icon
                        v-show="failed"
                        class="error"
                      >
                        close
                      </md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon
                        v-show="passed"
                        class="success"
                      >
                        done
                      </md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </div>
              </ValidationProvider>
            </div>
          </div>
          <div class="md-layout">
            <div
              class="md-layout-item"
              :class="{'md-size-100': fullWidth, 'md-size-50 md-medium-size-100': !fullWidth }"
              style="display: flex"
            >
              <label class="dots bold">Title</label>
              <div class="md-layout-item">
                <ValidationProvider
                  v-slot="{ passed, failed }"
                  name="title"
                  rules="required"
                >
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <md-input
                      v-model="activity.title"
                      type="text"
                    />
                  </md-field>
                  <slide-y-down-transition>
                    <md-icon
                      v-show="failed"
                      class="error"
                    >
                      close
                    </md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon
                      v-show="passed"
                      class="success"
                    >
                      done
                    </md-icon>
                  </slide-y-down-transition>
                </ValidationProvider>
              </div>
            </div>
            <div
              class="md-layout-item"
              :class="{'md-size-100': fullWidth, 'md-size-50 md-medium-size-100': !fullWidth }"
              style="display: flex"
            >
              <label class="dots bold">Dauer</label>
              <div style="display:flex; flex-direction: column">
                <div class="md-layout">
                  <div class="md-layout-item md-size-10 custom-style">
                    <ValidationProvider
                      v-slot="{ passed, failed }"
                      name="hours"
                      rules="min_value:0|max_value:23"
                    >
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <md-input
                          v-model="hours"
                          @keypress="isNumber($event)"
                        />
                      </md-field>
                    </ValidationProvider>
                  </div>
                  <span class="dots">:</span>
                  <div class="md-layout-item md-size-10 custom-style">
                    <ValidationProvider
                      v-slot="{ passed, failed }"
                      name="minutes"
                      rules="min_value:0|max_value:59"
                    >
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <md-input
                          v-model="minutes"
                          @keypress="isNumber($event)"
                        />
                      </md-field>
                    </ValidationProvider>
                  </div>
                  <span class="dots">:</span>
                  <div class="md-layout-item md-size-10 custom-style">
                    <ValidationProvider
                      v-slot="{ passed, failed }"
                      name="seconds"
                      rules="min_value:0|max_value:59"
                    >
                      <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                        <md-input
                          v-model="seconds"
                          @keypress="isNumber($event)"
                        />
                      </md-field>
                    </ValidationProvider>
                  </div>
                  <span class="dots description-info">(hh : mm : ss)</span>
                </div>
                <span
                  v-if="showFormMessage"
                  class="not-allowed-time"
                >Dauer sollte größer als 0 sein</span>
              </div>
            </div>
          </div>
          <div class="md-layout">
            <div
              class="md-layout-item"
              :class="{'md-size-100': fullWidth, 'md-size-50 md-medium-size-100': !fullWidth }"
              style="display: flex"
            >
              <label class="dots bold">Distanz in meters</label>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-60"
                  style="padding: 0 !important;"
                >
                  <md-field>
                    <md-input
                      v-model="distanceInMeters"
                      placeholder="0"
                      class="t-r"
                      @keypress="isNumber($event)"
                    />
                  </md-field>
                </div>
                <div
                  class="md-layout-item"
                  style="display: flex"
                >
                  <span class="dots description-info">({{ distanceInKm }} km)</span>
                </div>
              </div>
            </div>
            <div
              class="md-layout-item"
              :class="{'md-size-100': fullWidth, 'md-size-50 md-medium-size-100': !fullWidth }"
              style="display: flex"
            >
              <label class="dots bold">Tempo</label>
              <md-field>
                <md-input
                  :value="myTempo"
                  disabled
                />
              </md-field>
            </div>
          </div>
        </form>
      </div>
    </ValidationObserver>
    <div class="buttons">
      <md-button
        style="margin-right: 15px"
        @click="cancelClicked"
      >
        Abbrechen
      </md-button>
      <md-button
        type="submit"
        class="md-success"
        @click="submitForm"
      >
        Speichern
      </md-button>
    </div>
  </div>
</template>
<script>
import activity from '../../utils/activity.js';
import datetime from "../../utils/datetime";
import validation from "../../utils/validation";

import { extend } from 'vee-validate';
import { max_value, min_value, required } from "vee-validate/dist/rules";
import { Datetime } from "vue-datetime";
import DragAndDropComponent from './drag-and-drop-component';

extend("required", required);
extend("min_value", min_value);
extend("max_value", max_value);

export default {
  name: "ManualActivityForm",
  components: { datetime: Datetime, DragAndDropComponent },
  props: {
    activityFromParent: {
      type: Object,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      activity: {
        images: [],
        activityType: 1,
        data: {
          distanceInMeters: null,
          averagePaceInMinutesPerKilometer: 0,
        },
      },
      activityTypes: activity.getActivitiesWithValidData(),
      activityImage: [],
      durationInSeconds: 0,
      distanceInMeters: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      speedInKm: 0,
      minDatetime: null,
      maxDatetime: null,
      distanceInKm: 0,
      showFormMessage: false,
    }
  },
  methods: {
    ...activity,
    ...datetime,
    ...validation,
    cancelClicked() {
      this.$emit('cancelClicked');
    },
    updateTitleImage(data) {
      this.activity.titleImage = data;
    },
    submitForm() {
      this.$refs.validator.validate();
      this.activity.durationInSeconds = this.durationInSeconds;
      this.activity.data.distanceInMeters = +this.distanceInMeters;
      this.activity.externalDataSourceId = 40;
      this.activity.images = this.activityImage;

      this.$refs.validator.validate().then(res => {
        if(this.durationInSeconds === 0) {
          this.showFormMessage = true;
          return;
        }
        if (res) {
          this.$emit('submitClicked', this.activity)
        }
      })
    },
  },
  computed: {
    myTempo() {
      return this.speedInKm !== 0 ?
          this.formatPace(
              this.formatSpeed2Pace(this.speedInKm)
          )
          : '0 : 00 m/km'
    }
  },
  watch: {
    $route(to, from) {
      this.id = to.params.id;
    },
    // hours() {
    //   this.durationInSeconds = this.calculateTimeInSeconds();
    //   if (this.distanceInMeters !== 0) {
    //     this.speedInKm = this.distanceInMeters / this.durationInSeconds
    //   }
    // },
    // minutes() {
    //   this.durationInSeconds = this.calculateTimeInSeconds();
    //   if (this.distanceInMeters !== 0) {
    //     this.speedInKm = this.distanceInMeters / this.durationInSeconds
    //   }
    // },
    // seconds() {
    //   this.durationInSeconds = this.calculateTimeInSeconds();
    //   if (this.distanceInMeters !== 0) Geschwindigkeit{
    //     this.speedInKm = this.distanceInMeters / this.durationInSeconds
    //   }
    // },
    distanceInMeters(val) {
      this.speedInKm = val / this.durationInSeconds
      this.distanceInKm = val/1000;
    },
    showManualActivityDialog(val) {
      if (!val) {
        this.activity = {
          images: [],
          activityType: 1,
          data: {
            distanceInMeters: null,
            averagePaceInMinutesPerKilometer: 0,
          }
        }
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        this.activityImage = null;
      }
    },
    durationInSeconds(val) {
      if (val > 0) {
        this.showFormMessage = false;
      }
    }
  },
  mounted() {
    this.activity = this.activityFromParent ? this.activityFromParent : {};
    if (this.activityFromParent) {
      this.activityImage = this.activityFromParent.images.length ? this.activityFromParent.images : [];
      this.distanceInMeters = this.activityFromParent.data && this.activityFromParent.data.distanceInMeters || 0;

      this.durationInSeconds = this.activityFromParent.durationInSeconds;
      let n = this.activityFromParent.durationInSeconds % (3600);
     this.hours = parseInt(this.activityFromParent.durationInSeconds / 3600);

      n %= 3600;
      this.minutes = parseInt(n / 60);

      n %= 60;
      this.seconds = n;
    }
  }
}
</script>
